export * from './agris-edit-price-ins-cotiz-dialog.component';



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/agris/agris-cotizacion-detalle-page/agris-edit-price-ins-cotiz-dialog/index.ts